import React, { useState } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import axios from "axios";

import "./NowApprovedForm.scss";

export default function NowApprovedForm() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    agree: "",
    isSubmitting: false,
  });
  const [cantSubmit, setCantSubmit] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  // validate form
  const validateForm = () => {
    const newErrors = {};
    if (!formData.firstName.trim()) {
      newErrors.firstName = "Please complete this required field.";
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = "Please complete this required field.";
    }

    if (!formData.email.trim()) {
      newErrors.email =
        "Please complete this required field, ex: your@email.com";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email =
        "Please complete this required field, ex: your@email.com";
    }

    if (!formData.agree) {
      newErrors.agree =
        "Please indicate that you accept the terms and conditions.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    // cantSubmit if there is a problem with the PHP service.
    setCantSubmit(false);
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));

    // clear error if user is typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      // Prevent Duplicate submissions.
      if (formData.isSubmitting) {
        return;
      }
      // cantSubmit if there is a problem with the PHP service.
      setCantSubmit(false);

      // Continue submitting.
      formData.isSubmitting = true;
      let firstName = formData.firstName;
      let lastName = formData.lastName;
      let email = formData.email;
      // POST the data to the php service.
      axios({
        method: "post",
        url: '/service-now-approved.php',
        headers: {
          'content-type': 'application/json'
        },
        data: {
          firstName,
          lastName,
          email,
        }
      })
        .then(result => {
          formData.isSubmitting = false;
          if (result.data.requestId) {
            setIsSubmitted(true);
            window.scrollTo(0, 0);
          } else {
            setIsSubmitted(false);
            // cantSubmit if there is a problem with the PHP service.
            setCantSubmit(true);
            window.scrollTo(0, 0);
          }
        })
        .catch(error => {
          formData.isSubmitting = false;
          setIsSubmitted(false);
          // cantSubmit if there is a problem with the PHP service.
          setCantSubmit(true);
          window.scrollTo(0, 0);
        });
    }
  };

  // success - show thank you
  if (isSubmitted) {
    window.dataLayer.push({
      'event': 'nowApprovedFormSubmission',
      'form_name': 'now-approved-form',
      'form_action': 'field interaction',
      'form_field_status': "field completed",
      'form_field': "agree",
      'indication': "n/a",
      'click_identifier': "now-approved-form - complete field:agree",
    });
    return (
      <React.Fragment>
        <div className="now-approved-thank-you-wrapper">
          <div className="now-approved-thank-you">
            <h1>NICE!</h1>
            <p>
              You’ve successfully signed up—keep an eye out for information
              about the new and expanded indication coming your way.
            </p>
            <a href="/themes/pdf/prescribing-information.pdf" className="btn btn-primary download" target="_blank">
              <span>Prescribing Information</span>
            </a>
            {/* <img src="/images/thank-you-icon@2x.png" alt="" /> */}
          </div>
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="now-approved-form-wrapper">
        <GoogleReCaptchaProvider reCaptchaKey="6LfcafYZAAAAALR2odRkqSuTIibO0AlSVCwnFj3J">
          <form id="now-approved-form" onSubmit={handleSubmit} noValidate>
            <div className="form-group">
              <label htmlFor="firstName">First Name*</label>
              <input
                type="text"
                id="firstName"
                name="firstName"
                value={formData.firstName}
                onChange={handleInputChange}
                onBlur={handleInputChange}
                className={`input ${errors.firstName ? "error" : ""}`}
                placeholder="Type your first name"
              />
              {errors.firstName && (
                <p className="error-text">{errors.firstName}</p>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="lastName">Last Name*</label>
              <input
                type="text"
                id="lastName"
                name="lastName"
                value={formData.lastName}
                onChange={handleInputChange}
                className={`input ${errors.lastName ? "error" : ""}`}
                placeholder="Type your last name"
              />
              {errors.lastName && (
                <p className="error-text">{errors.lastName}</p>
              )}
            </div>
            <div className="form-group">
              <label htmlFor="email">Email address*</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className={`input ${errors.email ? "error" : ""}`}
                placeholder="your@email.com"
              />
              {errors.email && <p className="error-text">{errors.email}</p>}
            </div>
            <div className="form-group">
              <div className="checkbox-group">
                <input
                  type="checkbox"
                  id="agree"
                  name="agree"
                  checked={formData.agree}
                  onChange={handleInputChange}
                  className={`input checkbox ${errors.agree ? "error" : ""}`}
                />
                <label htmlFor="agree">
                  I agree to all the{" "}
                  <a
                    taget="_blank"
                    rel="noopener noreferrer"
                    href="https://www.sobi.com/usa/en/terms-and-conditions"
                  >
                    Terms
                  </a>{" "}
                  and{" "}
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.sobi.com/usa/en/privacy-policy-us"
                  >
                    Privacy Policy
                  </a>
                  .*
                </label>
              </div>
              {errors.agree && <p className="error-text">{errors.agree}</p>}
            </div>
            <div className="form-group form-actions">
              <button
                type="submit"
                className="form-submit btn btn-primary"
                onClick={handleSubmit}
              >
                <span>Submit</span>
              </button>
              {cantSubmit && <p className="error-text text-center">There was a problem submitting the form</p>}
            </div>
          </form>
        </GoogleReCaptchaProvider>
      </div>
    </React.Fragment>
  );
}
